/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sport/football/match/var': {
    width: 25,
    height: 25,
    viewBox: '0 0 25 25',
    data: '<rect pid="0" width="25" height="25" rx="6" _fill="#FFE9C9"/><path pid="1" d="M20.482 8.9a1.119 1.119 0 00-1.076-.074L17.123 9.88v-.04a.987.987 0 00-.986-.985h-1.4V7.363a.896.896 0 00-.895-.894H4.298a.298.298 0 100 .596h9.544c.164 0 .298.134.298.298v1.492H4.986A.988.988 0 004 9.84v7.571c0 .544.442.987.986.987h11.15a.987.987 0 00.987-.987v-.039l2.283 1.054a1.127 1.127 0 001.076-.074c.324-.207.518-.56.518-.946v-7.56c0-.386-.194-.74-.518-.947zm-3.956 8.512a.39.39 0 01-.39.39H4.987a.39.39 0 01-.39-.39V9.841a.39.39 0 01.39-.39h11.15a.39.39 0 01.39.39v7.571zm3.878-.005a.518.518 0 01-.243.444.515.515 0 01-.505.034l-2.533-1.168v-6.18l2.533-1.17a.516.516 0 01.504.035.519.519 0 01.244.444v7.561z" _fill="#F9941E"/>'
  }
})
